export default [
    {
        path: '/my-account',

        name: 'My Account',
        
        component: () => import('@/views/my-account'),
    },
    // {
    //     path: '/my-account/chats',
    //     name: 'ChatMeApp',
    //     component: () => import('@/views/my-account/content/chats'),
    // },
];